import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/moban/1.jpg'
import _imports_1 from '@/assets/moban/2.jpg'
import _imports_2 from '@/assets/moban/3.jpg'


const _hoisted_1 = { class: "landing-page" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "notification" }
const _hoisted_4 = { class: "notification-container" }

import { useRouter } from 'vue-router'
import { ref, onMounted, onUnmounted } from 'vue'
import OrderQuery from '@/components/OrderQuery.vue'
import { Bell } from '@element-plus/icons-vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'LandingPage',
  setup(__props) {

const router = useRouter()
const orderQueryVisible = ref(false)

// 通知相关数据
const notifications = ref<Array<{text: string, time: string}>>([])
const currentNotificationIndex = ref(0)
let notificationTimer: number | null = null

// 生成随机通知数据
const generateNotifications = () => {
  const topics = [
    '新课标',
    '人工智能',
    '数字化转型',
    '可持续发展',
    '科技创新',
    '教育现代化',
    '数字经济发展',
    '绿色环保',
    '智慧城市',
    '文化传承',
    '乡村振兴',
    '医疗健康',
    '金融科技',
    '生态环境保护',
    '社会治理',
    '区块链技术',
    '云计算应用',
    '大数据分析',
    '物联网发展',
    '5G技术应用',
    '智能制造',
    '新能源技术',
    '生物科技',
    '航天技术',
    '量子计算',
    '虚拟现实',
    '增强现实',
    '机器学习',
    '深度学习',
    '自然语言处理'
  ]
  
  const timeOptions = ['1分钟前', '5分钟前', '1小时前']
  const newNotifications = []
  
  // 生成6条随机通知
  const notificationCount = 6
  
  for (let i = 0; i < notificationCount; i++) {
    const topic = topics[Math.floor(Math.random() * topics.length)]
    const time = timeOptions[Math.floor(Math.random() * timeOptions.length)]
    
    newNotifications.push({
      text: `${time},论文《${topic}*****》生成成功`,
      time: time
    })
  }
  
  notifications.value = newNotifications
}

// 开始滚动通知
const startNotificationScroll = () => {
  notificationTimer = window.setInterval(() => {
    currentNotificationIndex.value = (currentNotificationIndex.value + 1) % notifications.value.length
  }, 3000) // 每3秒切换一次
}

// 定期刷新通知数据
let refreshTimer: number | null = null
const startRefreshTimer = () => {
  refreshTimer = window.setInterval(() => {
    generateNotifications()
    currentNotificationIndex.value = 0
  }, 30000) // 每30秒刷新一次通知数据
}

// 停止滚动通知
const stopNotificationScroll = () => {
  if (notificationTimer) {
    clearInterval(notificationTimer)
    notificationTimer = null
  }
}

// 停止刷新定时器
const stopRefreshTimer = () => {
  if (refreshTimer) {
    clearInterval(refreshTimer)
    refreshTimer = null
  }
}





const goToWriting = () => {
  // 获取当前URL的所有查询参数
  const urlParams = new URLSearchParams(window.location.search)
  
  // 如果存在查询参数，则在跳转时携带所有参数
  if (urlParams.toString()) {
    router.push(`/writing?${urlParams.toString()}`)
  } else {
    router.push('/writing')
  }
}

const goToUserGuide = () => {
  router.push('/user-guide')
}

const goToTemplateGallery = () => {
  router.push('/template-gallery')
}

const showOrderDownload = () => {
  orderQueryVisible.value = true
}

// 组件挂载时初始化
onMounted(() => {
  generateNotifications()
  startNotificationScroll()
  startRefreshTimer()
})

// 组件卸载时清理定时器
onUnmounted(() => {
  stopNotificationScroll()
  stopRefreshTimer()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[11] || (_cache[11] = _createStaticVNode("<div class=\"background-decoration\" data-v-fcbb7076><div class=\"stars\" data-v-fcbb7076></div><div class=\"floating-shapes\" data-v-fcbb7076><div class=\"shape shape-1\" data-v-fcbb7076></div><div class=\"shape shape-2\" data-v-fcbb7076></div><div class=\"shape shape-3\" data-v-fcbb7076></div><div class=\"shape shape-4\" data-v-fcbb7076></div></div><div class=\"floor-line\" data-v-fcbb7076></div></div>", 1)),
    _createElementVNode("header", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "logo" }, "芝麻开花智能写作平台", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(Bell), { class: "notification-icon" }),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: "notification-list",
            style: _normalizeStyle({ transform: `translateY(-${currentNotificationIndex.value * 30}px)` })
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notifications.value, (notification, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass(["notification-item", { active: index === currentNotificationIndex.value }])
              }, _toDisplayString(notification.text), 3))
            }), 128))
          ], 4)
        ])
      ])
    ]),
    _createElementVNode("main", { class: "main-content" }, [
      _createElementVNode("div", { class: "hero-section" }, [
        _cache[5] || (_cache[5] = _createElementVNode("h1", { class: "main-headline" }, "国家开放大学·论文生成系统", -1)),
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "description" }, [
          _createElementVNode("p", null, "500万学员正在使用完成毕业论文 | 可自定义目录 | 低查重率"),
          _createElementVNode("p", null, "自动生成Word格式论文 | 格式自动生成 | 可直接下载打印")
        ], -1)),
        _createElementVNode("div", { class: "action-buttons" }, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: goToWriting
          }, _cache[2] || (_cache[2] = [
            _createElementVNode("svg", {
              class: "btn-icon",
              viewBox: "0 0 24 24",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              _createElementVNode("path", {
                d: "M3 17.25V21H6.75L17.81 9.94L14.06 6.19L3 17.25ZM20.71 7.04C21.1 6.65 21.1 6.02 20.71 5.63L18.37 3.29C17.98 2.9 17.35 2.9 16.96 3.29L15.13 5.12L18.88 8.87L20.71 7.04Z",
                fill: "currentColor"
              })
            ], -1),
            _createTextVNode(" 生成论文 ")
          ])),
          _createElementVNode("button", {
            class: "btn btn-secondary",
            onClick: showOrderDownload
          }, _cache[3] || (_cache[3] = [
            _createElementVNode("svg", {
              class: "btn-icon",
              viewBox: "0 0 24 24",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              _createElementVNode("path", {
                d: "M19 9H15V3H9V9H5L12 16L19 9ZM5 18V20H19V18H5Z",
                fill: "currentColor"
              })
            ], -1),
            _createTextVNode(" 订单下载 ")
          ])),
          _createElementVNode("button", {
            class: "btn btn-info",
            onClick: goToUserGuide
          }, _cache[4] || (_cache[4] = [
            _createElementVNode("svg", {
              class: "btn-icon",
              viewBox: "0 0 24 24",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              _createElementVNode("path", {
                d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V11H13V17ZM13 9H11V7H13V9Z",
                fill: "currentColor"
              })
            ], -1),
            _createTextVNode(" 用前必看 ")
          ]))
        ])
      ]),
      _createElementVNode("div", { class: "sample-section" }, [
        _cache[10] || (_cache[10] = _createElementVNode("h2", { class: "section-title" }, "范文", -1)),
        _createElementVNode("div", { class: "image-gallery" }, [
          _createElementVNode("div", {
            class: "image-item",
            onClick: goToTemplateGallery
          }, _cache[7] || (_cache[7] = [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "示例图片1"
            }, null, -1)
          ])),
          _createElementVNode("div", {
            class: "image-item",
            onClick: goToTemplateGallery
          }, _cache[8] || (_cache[8] = [
            _createElementVNode("img", {
              src: _imports_1,
              alt: "示例图片2"
            }, null, -1)
          ])),
          _createElementVNode("div", {
            class: "image-item",
            onClick: goToTemplateGallery
          }, _cache[9] || (_cache[9] = [
            _createElementVNode("img", {
              src: _imports_2,
              alt: "示例图片3"
            }, null, -1)
          ]))
        ])
      ])
    ]),
    _createVNode(OrderQuery, {
      visible: orderQueryVisible.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (orderQueryVisible.value = $event))
    }, null, 8, ["visible"])
  ]))
}
}

})